import { tempoApi } from '@/lib/api/tempoApi';
import type { TimeLineDataSet, TimelineItem } from '@/lib/api/types/adaptive-planner/scenario-item';

const getDataSet = async ({ loopId, scenarioId }: { loopId: number; scenarioId: number }) => {
  const response = await tempoApi()
    .get(`api/v1/adaptive-planner/loops/${loopId}/scenarios/${scenarioId}/timeline-items/data-set`)
    .json<TimeLineDataSet[]>();
  return response;
};

const bulkFetch = async ({
  loopId,
  scenarioId,
  itemIds,
}: {
  loopId: number;
  scenarioId: number;
  itemIds: number[];
}) => {
  const response = await tempoApi()
    .post(
      `api/v1/adaptive-planner/loops/${loopId}/scenarios/${scenarioId}/timeline-items/bulk-fetch`,
      { json: itemIds },
    )
    .json<TimelineItem[]>();
  return response;
};

export const LoopPlannerTimelineItemsApi = {
  getDataSet,
  bulkFetch,
} as const;
